export default __webpack_public_path__ + "static/media/home_elwa_icon_as_device.bca25739.svg";